export default __webpack_public_path__ + "static/media/news99.4abf3666.jpg";